export const USDC_TOKEN = 'USDC';

export const USDAI_TOKEN = 'USDAI';

export enum EAvailableCurrency {
  AITECH = 'AITECH',
  USDC = 'USDC',
  USDAI = 'USDAI',
}
